export abstract class ActiveHighlightableString {
  private static activePartIds: string[] = [];

  static getActivePartIds(): string[] {
    return this.activePartIds;
  }

  static setActivePartIds(ids: string[]) {
    this.activePartIds = Array.from(ids);
  }

  static clearActivePartIds() {
    this.activePartIds = [];
  }
}
